import { ErrorBoundary } from 'react-error-boundary';

import { Modal, type ModalProps } from '@/components/Modal';
import { Spinner } from '@/components/Spinner';

import styles from '@/views/MovieDetailsView/MoviePlayerContext/PlayerModal.module.scss';
import { MoviePlayer } from '@/views/MovieDetailsView/components/MoviePlayer';
import { SerialPlayer } from '@/views/MovieDetailsView/components/SerialPlayer';

// =================================================================

interface PlayerModalProps extends Omit<ModalProps, 'children' | 'className'> {
  title: string;
  isSerial: boolean;
  isFetchingFeed: boolean;
}

// =================================================================

export const PlayerModal = (props: PlayerModalProps) => {
  const { title, isSerial, onClose, isOpen, isFetchingFeed, ...rest } = props;

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      className={styles.playerModal}
      modalInnerContainerClassName={styles.playerModalInner}
      {...rest}
    >
      {!isFetchingFeed ? (
        <ErrorBoundary fallback={<div>Что-то пошло не так...</div>}>
          {isSerial ? <SerialPlayer /> : <MoviePlayer />}
        </ErrorBoundary>
      ) : (
        <Spinner width="100px" height="100px" variant="signature" />
      )}
    </Modal>
  );
};
